import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saInterCuInterFreqHandoutChartConfig } from '../chartConfigs';

interface InterCuInterFreqHandoutSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const InterCuInterFreqHandoutSaEcharts: React.FC<InterCuInterFreqHandoutSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saInterCuInterFreqHandoutChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default InterCuInterFreqHandoutSaEcharts;
